<div #teamKit></div>
<svg *ngIf="svgIsLoaded">
    <use [attr.xlink:href]="svgIcon"></use>
</svg>
